import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57ebad79")

_pushScopeId("data-v-57ebad79")
const _hoisted_1 = {
  key: 1,
  class: "aviaCard__main hoverShadow"
}
const _hoisted_2 = { key: 2 }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AviaSlider = _resolveComponent("AviaSlider")
  const _component_AviaHead = _resolveComponent("AviaHead")
  const _component_AviaRoute = _resolveComponent("AviaRoute")
  const _component_AviaBottom = _resolveComponent("AviaBottom")
  const _component_avia_fare_info = _resolveComponent("avia-fare-info")

  return (_openBlock(), _createBlock("div", {
    class: ["aviaCard", { isOpenSlider: _ctx.showInfo }]
  }, [
    (_ctx.item)
      ? (_openBlock(), _createBlock(_component_AviaSlider, {
          key: 0,
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_AviaHead, {
            onClick: _ctx.toogleSlider,
            item: _ctx.item
          }, null, 8, ["onClick", "item"]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allLegs, (leg) => {
            return (_openBlock(), _createBlock(_component_AviaRoute, {
              leg: leg,
              key: leg.key,
              small: _ctx.small
            }, null, 8, ["leg", "small"]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createVNode(_component_AviaBottom, {
            item: _ctx.item,
            showTarrif: _ctx.showTarrif,
            btnTarrif: _ctx.btnTarrif,
            deleteTicket: _ctx.deleteTicket,
            isSelected: _ctx.isSelected,
            tripId: _ctx.tripId,
            isModeOffer: _ctx.isModeOffer,
            toogleFareInfo: _ctx.toogleFareInfo,
            onSelectOffer: _cache[1] || (_cache[1] = $event => (_ctx.$emit('select-offer', $event))),
            onUnselectOffer: _cache[2] || (_cache[2] = $event => (_ctx.$emit('unselect-offer', null))),
            isCansel: _ctx.isCansel,
            hasCansel: _ctx.hasCansel,
            hasControl: _ctx.hasControl
          }, null, 8, ["item", "showTarrif", "btnTarrif", "deleteTicket", "isSelected", "tripId", "isModeOffer", "toogleFareInfo", "isCansel", "hasCansel", "hasControl"]),
          _createVNode(_Transition, { name: "grow" }, {
            default: _withId(() => [
              (_ctx.item && _ctx.showFareInfo)
                ? (_openBlock(), _createBlock(_component_avia_fare_info, {
                    key: 0,
                    item: _ctx.item,
                    isSelected: _ctx.isSelected
                  }, null, 8, ["item", "isSelected"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.item)
      ? (_openBlock(), _createBlock("div", _hoisted_2, "нет данных !!!!"))
      : _createCommentVNode("", true)
  ], 2))
})